'use strict';

export const SBO_ERRORS = {
  INVALID_QUANTITY: 'invalidQuantityError',
  MINIMUM_QUANTITY: 'minimumQuantityError',
  MAXIMUM_QUANTITY: 'maximumQuantityError',
  INVALID_INCREMENT: 'invalidIncrementError'
};

// Which mode the packaging checkboxes are in
export const SBO_PACKAGING_MODE = {
  NONE: 'none',
  RADIO: 'radio',
  CHECKBOX: 'checkbox'
};

export const SBO_ALLOCATION_MODE = {
  DEFAULT: 'default',
  BACKORDER: 'backorder',
  BACKORDER_INFINITE: 'backorderInfinite'
};



// WEBPACK FOOTER //
// ./assets/components/SingleBuyingOptions/SingleBuyingOptionConstants.js